<div class="grid">
  <div class="col-12 mb-2">
    <div class="card title-card flex">
      <i class="pi pi-briefcase title-card-icon"></i>
      <div>
        <p class="mb-0 text-3xl title">{{ 'model.users' | transloco }}</p>
        <p>{{ 'menu.descriptions.users' | transloco }}</p>
      </div>
    </div>
  </div>
  <div class="col-12">
    <div class="card">
      <div class="p-datatable p-component p-datatable-hoverable-rows">
        <div class="p-datatable-header">
          <div class="flex flex-column sm:flex-row justify-content-between">
            <div class="flex flex-column md:flex-row">
              <button
                *ngIf="'ROLE_ADMIN' | userHasRole"
                [label]="'common.new' | transloco"
                pButton
                pRipple
                class="md:mr-2 p-button-primary mb-2 md:mb-0"
                routerLink="new"
                icon="pi pi-plus"
              ></button>
              <button
                *ngIf="'ROLE_ADMIN' | userHasRole"
                [label]="'common.delete' | transloco"
                [disabled]="selected.length == 0"
                (click)="confirmAndDeleteSelected()"
                pButton
                pRipple
                class="p-button-danger mb-2 sm:mb-0"
                icon="pi pi-trash"
              ></button>
            </div>
            <div *ngIf="!filtersForm.valid" class="flex flex-column md:flex-row justify-content-end">
              <button
                [label]="'common.filters' | transloco"
                (click)="filtersVisible = !filtersVisible"
                pButton
                class="p-button-secondary"
                icon="pi pi-sliders-h"
              ></button>
            </div>
            <div *ngIf="filtersForm.valid" class="flex flex-column md:flex-row justify-content-end">
              <button
                [label]="'common.filters' | transloco"
                (click)="filtersVisible = !filtersVisible"
                pButton
                class="p-button-secondary filtersFilled"
                icon="pi pi-filter"
              ></button>
            </div>
          </div>
        </div>
        <p-table
          [(first)]="first"
          [(rows)]="rows"
          [(selection)]="selected"
          [value]="users"
          [totalRecords]="totalUsers"
          [responsive]="true"
          [breakpoint]="'DATATABLE_BREAKPOINT' | appConfig"
          [paginator]="true"
          [rowsPerPageOptions]="[10,25,50]"
          [lazy]="true"
          (onLazyLoad)="onPageChange($event)"
          styleClass="p-datatable-striped"
          sortField="name"
        >
          <ng-template pTemplate="header">
            <tr>
              <th scope="col" class="w-3rem" *ngIf="authGuard.adminRequired()"></th>
              <th scope="col" *ngIf="authGuard.superAdminRequired()">
                {{ 'model.tenant' | transloco }}
              </th>
              <th scope="col" *ngIf="authGuard.superAdminRequired() || !userBelongsToSpecificOrganization">
                {{ 'model.organization' | transloco }}
              </th>
              <th scope="col">
                {{ 'attribute.username' | transloco }}
              </th>
              <th scope="col" *ngIf="authGuard.superAdminRequired()">
                {{ 'attribute.uuid' | transloco }}
              </th>
              <th scope="col" class="w-10rem" *ngIf="authGuard.adminRequired">
                {{ 'common.actions' | transloco }}
              </th>
            </tr>
          </ng-template>
          <ng-template pTemplate="body" let-user>
            <tr *ngIf="!loadingUsers" class="fadein">
              <td *ngIf="authGuard.adminRequired">
                <span class="p-column-title bold">{{ 'common.select' | transloco }}</span>
                <p-tableCheckbox [value]="user"></p-tableCheckbox>
              </td>
              <td *ngIf="authGuard.superAdminRequired()">
                <span class="p-column-title bold">{{ 'model.tenant' | transloco }}</span>
                <p class="text-right md:text-left">{{ user.tenantUUID | tenantsResolver }}</p>
              </td>
              <td *ngIf="authGuard.superAdminRequired() || !userBelongsToSpecificOrganization">
                <span class="p-column-title bold">{{ 'model.organization' | transloco }}</span>
                <p class="text-right md:text-left">{{ user.organizationUUID | organizationsResolver }}</p>
              </td>
              <td>
                <span class="p-column-title bold">{{ 'attribute.username' | transloco }}</span>
                {{ user.username }}
              </td>
              <td *ngIf="authGuard.superAdminRequired()">
                <span class="p-column-title bold">{{ 'attribute.uuid' | transloco }}</span>
                <p class="text-right md:text-left">{{ user.uuid }}</p>
              </td>
              <td *ngIf="authGuard.adminRequired()">
                <span class="p-column-title bold">{{ 'common.actions' | transloco }}</span>
                <div class="flex justify-content-end">
                  <button *ngIf="user.editable"
                    [routerLink]="user.uuid + '/'+ user.tenantUUID + '/edit'"
                    pButton
                    pRipple
                    class="p-button-rounded btn-primary-light mr-2"
                    icon="pi pi-pencil"
                  ></button>
                  <button
                    *ngIf="loggedUser.user.uuid !== user.uuid"
                    (click)="confirmAndDelete(user)"
                    pButton
                    pRipple
                    class="p-button-rounded btn-danger-light"
                    icon="pi pi-trash"
                  ></button>
                </div>
              </td>
            </tr>
            <tr *ngIf="loadingUsers" class="fadein animation-delay-200 animation-fill-forwards no-opacity">
              <td class="row-height selection-column-width">
                <p-skeleton height="1em"></p-skeleton>
              </td>
              <td class="row-height">
                <p-skeleton height="1em"></p-skeleton>
              </td>
              <td class="row-height">
                <p-skeleton height="1em"></p-skeleton>
              </td>
              <td class="row-height">
                <p-skeleton height="1em"></p-skeleton>
              </td>
              <td class="row-height">
                <p-skeleton height="1em"></p-skeleton>
              </td>
              <td class="row-height">
                <p-skeleton height="1em"></p-skeleton>
              </td>
            </tr>
          </ng-template>
          <ng-template pTemplate="summary">
            <div class="flex align-items-center justify-content-between" *ngIf="totalUsers == 0">
              {{ 'pagination.empty' | transloco }}
            </div>
            <div class="flex align-items-center justify-content-between" *ngIf="totalUsers > 0">
              {{ 'pagination.showing' | transloco }} {{ first + 1 }}
              {{ 'pagination.to' | transloco }} {{ (first + rows) >= totalUsers ? totalUsers : (first + rows) }}
              {{ 'pagination.of' | transloco }} {{ totalUsers }}
              {{ (totalUsers > 1 ? 'pagination.entries' : 'pagination.entry') | transloco }}
            </div>
          </ng-template>
        </p-table>
      </div>
    </div>
  </div>
</div>

<p-sidebar [(visible)]="filtersVisible" position="right" [baseZIndex]="10000" [style]="{'width':'25em'}">
  <h2 style="margin-left: 10px">{{ 'common.filters' | transloco }}</h2>
  <form [formGroup]="filtersForm" (ngSubmit)="applyFilters()">
    <div class="col-12">
      <div class="col-12 form-field">
        <label for="username">{{ 'attribute.username' | transloco }}</label>
      </div>
      <div class="col-12 form-field">
        <input
          [focus]="filtersVisible"
          pInputText
          appAutoFocus
          class="w-full"
          id="username"
          type="text"
          formControlName="username"
        >
      </div>
      <div *ngIf="authGuard.superAdminRequired()" class="col-12 form-field">
        <label for="tenant">{{ 'attribute.tenant' | transloco }}</label>
      </div>
      <div *ngIf="authGuard.superAdminRequired()" class="col-12 form-field">
        <p-dropdown
          appAutoFocus [focus]="filtersVisible" [filter]="true" [showClear]="true" styleClass="w-full" id="tenant"
          [options]="tenantOptions"
          optionLabel="name"
          optionValue="uuid"
          placeholder="{{('select.tenant' | transloco) || ' '}}" appendTo="body"
          formControlName="tenant"
        ></p-dropdown>
      </div>
      <div *ngIf="'ROLE_ADMIN' | userHasRole: false" class="col-12 form-field">
        <label for="organization">{{ 'model.organization' | transloco }}</label>
      </div>
      <div *ngIf="'ROLE_ADMIN' | userHasRole: false" class="col-12 form-field">
        <p-dropdown
          appAutoFocus [focus]="filtersVisible" [filter]="true" [showClear]="true" styleClass="w-full" id="organization"
          [options]="organizationOptions"
          optionLabel="name"
          optionValue="uuid"
          placeholder="{{('select.organization' | transloco) || ' '}}"
          appendTo="body"
          formControlName="organization"
        ></p-dropdown>
      </div>
    </div>
    <div class="col-12">
      <p-button
        [label]="'common.filter' | transloco"
        [disabled]="!filtersForm.valid"
        styleClass="p-button-primary mx-2 mt-2"
        type="submit"
      ></p-button>
      <p-button
        [label]="'common.clear' | transloco"
        (click)="resetFilters()"
        styleClass="p-button-danger"
        type="button"
      ></p-button>
    </div>
  </form>
</p-sidebar>
